import type { Store } from "pinia";

export async function isModuleReady(store: Store) {
  if (store.$persistedState && store.$persistedState.isReady) {
    await store.$persistedState.isReady();
  }

  return true;
}

export function useChunkList() {
  const screenGrid = useScreenGrid();
  const windowSize = useWindowSize();
  const chunkSize = computed(() => {
    if (!import.meta.client) return 1;
    switch (true) {
      case screenGrid.xxl && +windowSize.width.value >= 1536:
        return 4;

      case screenGrid.xxl && +windowSize.width.value < 1536:
        return 3;

      case screenGrid.xl:
        return 3;

      case screenGrid.md:
        return 2;

      default:
        return 1;
    }
  });
  return {
    chunkSize,
  };
}
